import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { API, authedFetch } from "../lib/api";
import { X, Loader2 } from "lucide-react";

let lightboxSetters = null;

export function openLightbox(path, caption = "") {
  if (lightboxSetters) lightboxSetters({ path, caption });
}

export default function LightboxProvider() {
  const [item, setItem] = useState(null);
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    lightboxSetters = setItem;
    return () => {
      lightboxSetters = null;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    setBlobUrl(null);
    if (!item?.path) return;
    (async () => {
      try {
        const res = await authedFetch(`${API}/files/${item.path}`);
        if (!res.ok) return;
        const b = await res.blob();
        const u = URL.createObjectURL(b);
        if (cancelled) URL.revokeObjectURL(u);
        else setBlobUrl(u);
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [item]);

  useEffect(() => {
    return () => {
      if (blobUrl) {
        try { URL.revokeObjectURL(blobUrl); } catch { /* ignore */ }
      }
    };
  }, [blobUrl]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setItem(null);
    };
    if (item) {
      window.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [item]);

  if (!item) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] bg-black/90 flex flex-col items-center justify-center p-4"
      onClick={() => setItem(null)}
      data-testid="lightbox-overlay"
    >
      <button
        className="absolute top-4 right-4 text-white bg-white/10 hover:bg-white/20 backdrop-blur p-2 rounded-full"
        onClick={() => setItem(null)}
        aria-label="Chiudi"
        data-testid="lightbox-close"
      >
        <X className="w-6 h-6" />
      </button>
      <div className="relative max-w-[95vw] max-h-[85vh] flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
        {blobUrl ? (
          <img
            src={blobUrl}
            alt={item.caption || "foto"}
            className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
            data-testid="lightbox-image"
          />
        ) : (
          <div className="bg-white/10 backdrop-blur rounded-xl p-8">
            <Loader2 className="w-8 h-8 animate-spin text-white" />
          </div>
        )}
      </div>
      {item.caption && (
        <div className="mt-4 text-white text-sm bg-black/50 backdrop-blur px-4 py-2 rounded-full" data-testid="lightbox-caption">
          {item.caption}
        </div>
      )}
    </div>,
    document.body,
  );
}
